// extracted by mini-css-extract-plugin
module.exports = {"circle":"speaking_circle__152AJ","padding":"speaking_padding__zhVWF","content":"speaking_content__3z7Rg","image":"speaking_image__jbu5c"};